/**
 * SK labely kategórií materiálov (kódy z importérov cenníkov).
 * Zdieľané medzi CennikPage, MaterialEditDialog a ďalšími.
 */

export const KATEGORIA_LABELS: Record<string, string> = {
  DTD_8: "DTD 8 mm", DTD_10: "DTD 10 mm", DTD_12: "DTD 12 mm",
  DTD_14: "DTD 14 mm", DTD_15: "DTD 15 mm", DTD_16: "DTD 16 mm",
  DTD_18: "DTD 18 mm", DTD_19: "DTD 19 mm", DTD_20: "DTD 20 mm",
  DTD_22: "DTD 22 mm", DTD_23: "DTD 23 mm", DTD_25: "DTD 25 mm",
  DTD_26: "DTD 26 mm", DTD_27: "DTD 27 mm", DTD_28: "DTD 28 mm",
  DTD_30: "DTD 30 mm", DTD_32: "DTD 32 mm", DTD_38: "DTD 38 mm",
  DTD_40: "DTD 40 mm", DTD_50: "DTD 50 mm", DTD_60: "DTD 60 mm",
  DTD_2: "DTD 2 mm", DTD_3: "DTD 3 mm", DTD_4: "DTD 4 mm",
  DTD_5: "DTD 5 mm", DTD_6: "DTD 6 mm", DTD_7: "DTD 7 mm",
  MDF: "MDF", HDF: "HDF", HPL: "HPL", MASIV: "Masív", SKLO: "Sklo",
  KOMPAKT: "Kompakt (HPL dosky)",
  SOLOLIT: "Sololit",
  PREGLEJKA: "Preglejka", UMAKART: "Umakart", POSTFORMING: "Postforming",
  // Typy dosiek bez dekoru (KOLO 167, `services/typy_dosiek.py`)
  SKAROVKA: "Škárovka", BIODOSKA: "Biodoska", LATOVKA: "Laťovka",
  DYHOVANA: "Dyhovaná doska", CORIAN: "Corian / solid surface",
  // Lamináty (KOLO 187) — list do 3 mm, inak doska potiahnutá laminátom
  LAMINAT: "Laminát (list)", LAMINAT_DOSKA: "Doska potiahnutá laminátom",
  HRANA_UZKA_05: "Úzka hrana (≤18mm) 0,5 mm", HRANA_UZKA_1: "Úzka hrana (≤18mm) 1 mm", HRANA_UZKA_2: "Úzka hrana (≤18mm) 2 mm",
  HRANA_STREDNA_05: "Stredná hrana (19-25mm) 0,5 mm", HRANA_STREDNA_1: "Stredná hrana (19-25mm) 1 mm", HRANA_STREDNA_2: "Stredná hrana (19-25mm) 2 mm",
  HRANA_SIRSIA_05: "Stredne široká (26-35mm) 0,5 mm", HRANA_SIRSIA_1: "Stredne široká (26-35mm) 1 mm", HRANA_SIRSIA_2: "Stredne široká (26-35mm) 2 mm",
  HRANA_SIROKA_05: "Široká hrana (36-45mm) 0,5 mm", HRANA_SIROKA_1: "Široká hrana (36-45mm) 1 mm", HRANA_SIROKA_2: "Široká hrana (36-45mm) 2 mm",
  BLOK_05: "Blok (>45mm) 0,5 mm", BLOK_1: "Blok (>45mm) 1 mm", BLOK_2: "Blok (>45mm) 2 mm",
  HRANOL_DREVO: "Hranoly drevo", PRACOVNA_DOSKA_DL: "Pracovná doska (dĺžková)",
  ZASTENA: "Zásteny",
  SKLO_KALENIE: "Kalenie skla",
  // ── Kovanie — rodičovské skupiny (Demos sekcie) ──
  KOVANIE_ZAVES: "Závesy", KOVANIE_VYSUV: "Výsuvy",
  KOVANIE_VYKLAPANIE: "Výklopy (Aventos, piesty)",
  KOVANIE_NOHA: "Nohy a podnoží", KOVANIE_UCHYTKA: "Úchytky",
  KOVANIE_ZAMOK: "Zámky", KOVANIE_PODPERKA: "Podperky políc",
  KOVANIE_PROFIL: "Profily AL", KOVANIE_ORGANIZACIA: "Organizácia",
  KOLIESKA: "Kolieska a klzáky",
  DREZ_BATERIA: "Drezy a batérie", UMYVADLO: "Umývadlá",
  DROTENY_PROGRAM: "Drôtený program / koše",
  TLMIC_MAGNET: "Tlmiče a magnety", TESNENIE: "Tesnenia",
  ROLETKA: "Roletky", ELEKTRO: "Elektro / zásuvky",
  OSVETLENIE: "Osvetlenie LED", DVER_KOVANIE: "Dverné kovanie",
  SKLO_KUSOVE: "Sklo a zrkadlá", KOVANIE_SKLO: "Kovanie pre sklo",
  VETRACIA_MRIEZKA: "Vetracie mriežky",
  SPOJOVACI_MATERIAL: "Spojovací materiál", ODPAD_SORTOVANIE: "Odpad / sortovanie",
  KOVANIE_POSUVNE: "Posuvné dvere (systémy)",
  KOVANIE_SOKEL: "Soklové profily",
  KOVANIE_KANCELARIA: "Kancelárske diely",
  KOVANIE_POSTEL: "Posteľové a WC kovanie",
  // ── Kovanie — podskupiny (Demos strom, R2) ──
  KOVANIE_ZAVES_TLMENY: "Závesy s tlmením",
  KOVANIE_ZAVES_MECHANICKY: "Závesy mechanické",
  KOVANIE_VYSUV_KOLIESKOVY: "Výsuvy kolieskové",
  KOVANIE_VYSUV_BEZ_TLMENIA: "Výsuvy bez tlmenia",
  KOVANIE_VYSUV_GULICKOVY: "Výsuvy guličkové (plnovýsuvy)",
  KOVANIE_VYSUV_BOX: "Boxové systémy (StrongBox, TANDEMBOX…)",
  KOVANIE_VYSUV_SKRYTY: "Výsuvy skryté (tenké bočnice)",
  KOVANIE_VYSUV_OCELOVY: "Výsuvy oceľové",
  KOVANIE_ZAMOK_MECHANICKY: "Zámky mechanické",
  KOVANIE_ZAMOK_ELEKTRONICKY: "Zámky elektronické",
  KOVANIE_KNOPKA: "Knopky",
  KOVANIE_UCHYTKA_ZAPUSTNA: "Zápustné úchytky",
  KOVANIE_VESIAK: "Vešiaky",
  KOVANIE_PROFIL_GOLA: "Gola profily (bezúchytkové)",
  DVER_KOVANIE_KLUCKA: "Kľučky",
  DVER_KOVANIE_ZAVES: "Dverné závesy",
  DVER_KOVANIE_ZAMOK: "Dverné zámky",
  KOVANIE_POSUVNE_DREVO: "Posuvné systémy — drevo",
  KOVANIE_POSUVNE_TOPLINE: "Posuvné systémy — TopLine",
  DROTENY_PROGRAM_POTRAVINOVE: "Potravinové skrine",
  DROTENY_PROGRAM_KOSE: "Výsuvné koše a topánkovníky",
  SPOJOVACI_MATERIAL_EXCENTER: "Excentre a tiahla",
  SPOJOVACI_MATERIAL_ELEMENT: "Spojovacie elementy a kolíky",
  SPOJOVACI_MATERIAL_EUROSKRUTKA: "Euroskrutky",
  SPOJOVACI_MATERIAL_KRYTKA: "Plastové krytky",
  SPOJOVACI_MATERIAL_TESARSKE: "Tesárske kovanie",
  KOVANIE_NOHA_STOLOVA: "Stolové nohy",
  KOVANIE_NOHA_REKTIFIKACNA: "Rektifikačné nohy (soklové)",
  KOVANIE_NOHA_NOZICKA: "Nábytkové nožičky",
  DREZ_BATERIA_DREZ: "Drezy",
  DREZ_BATERIA_BATERIA: "Batérie",
  KOVANIE_KANCELARIA_KONTAJNER: "Komplety kontajnerov",
  KOVANIE_KANCELARIA_PODNOZ: "Stolové podnože",
  KOVANIE_VYKLAPANIE_PIEST: "Zdviháky na piest",
  KOVANIE_UCHYTKA_MADLO: "Madlá",
  KOVANIE_UCHYTKA_PROFILOVA: "Profilové úchytky (RiexTouch…)",
  ELEKTRO_ZASUVKA: "Elektrické zásuvky",
  KOLIESKA_KOLIESKO: "Kolieska",
  KOLIESKA_KLZAK: "Klzáky",
  DROTENY_PROGRAM_SATNIK: "Šatníkové tyče a doplnky",
  DEFAULT: "Ostatné (nekategorizované)",
  _DEFAULT_KUSOVE: "Ostatné (nezaradené kovanie)",
};

/**
 * Krátky názov kovania odvodený z kategórie — pre default názov dielca
 * ("Výklopy (Aventos, piesty)" → "Výklopy"). Bez kategórie vráti null.
 */
export function kovanieNazov(kategoria?: string | null): string | null {
  if (!kategoria) return null;
  const label = KATEGORIA_LABELS[kategoria] ?? formatKategoria(kategoria);
  return label.replace(/\s*\([^)]*\)\s*$/, "").trim() || null;
}

/**
 * Predvolený názov riadku s kovaním (KOLO 176): alias, ako si ho user
 * pomenoval; bez neho krátky názov kategórie a nakoniec pravý názov.
 */
export function predvolenyNazovKovania(m: {
  nazov: string;
  alias?: string | null;
  kategoria?: string | null;
}): string {
  return m.alias?.trim() || kovanieNazov(m.kategoria) || m.nazov;
}

/**
 * Je názov riadku ešte ten, ktorý dala appka pre toto kovanie (alias,
 * kategória alebo pravý názov)? Taký sa pri výmene kovania prepíše,
 * vlastný názov od usera nie.
 */
export function jePredvolenyNazovKovania(
  nazov: string | null | undefined,
  m: { nazov: string; alias?: string | null; kategoria?: string | null } | null | undefined,
): boolean {
  const n = (nazov ?? "").trim();
  if (!n) return true;
  if (!m) return false;
  return [m.alias?.trim(), kovanieNazov(m.kategoria), m.nazov].includes(n);
}

/**
 * Má materiál zmysel percentuálneho odpadu (nadmiera_pct)? Odpad %
 * násobí materiálovú zložku ceny — má zmysel len pri doskách (plošné
 * a dĺžkové dosky/pracovné dosky). Hrany majú vlastnú fixnú mm nadmieru
 * a kovanie odpad nenesie, takže tam je pole zavádzajúce.
 *
 * `sekcia` zo servera (`Material.sekcia`, KOLO 166) rozhoduje, keď je
 * známa — odpad majú len Materiály. Bez nej (nová kategória vo
 * formulári) ostáva odhad podľa prefixu, ktorý dĺžkové krytky
 * a šatníkové tyče nepozná.
 */
export function materialMaOdpad(
  druh?: string | null,
  kategoria?: string | null,
  sekcia?: string | null,
): boolean {
  if (sekcia) return sekcia === "materialy";
  if (druh === "plosny") return true;
  if (druh === "kusovy") return false;
  const k = kategoria ?? "";
  return !(
    k.startsWith("HRANA_") ||
    k.startsWith("KOVANIE_") ||
    k.startsWith("OSVETLENIE") ||
    k.startsWith("ELEKTRO")
  );
}

/** SK label kategórie — známy kód z tabuľky, inak heuristický fallback. */
export function formatKategoria(kat: string): string {
  if (KATEGORIA_LABELS[kat]) return KATEGORIA_LABELS[kat];
  return kat
    .replace(/_/g, " ")
    .replace(/HRANA (\d+) (\d+)/g, "Hrana $1 x $2 mm")
    .replace(/DTD (\d+)/g, "DTD $1 mm");
}

/**
 * Kódy kategórií pre výber v okne materiálu: jeden kód raz (kovanie býva
 * v dvoch druhoch), zoradené podľa čitateľného názvu s číslami ako čísla
 * (DTD 8 mm pred DTD 10 mm).
 */
export function kodyKategorii(polozky: readonly { kod: string }[]): string[] {
  return [...new Set(polozky.map((p) => p.kod))].sort((a, b) =>
    formatKategoria(a).localeCompare(formatKategoria(b), "sk", {
      numeric: true,
    }),
  );
}
